// Fix timezone issue - parse date as local timezone, not UTC
export const parseLocalDate = (dateString) => {
  if (!dateString) return null;
  const parts = dateString.split('-');
  if (parts.length !== 3) return null;
  // Create date in local timezone (year, month-1, day)
  return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
};

// Get date string for input (YYYY-MM-DD format)
export const toDateInputValue = (date) => {
  if (!date) return '';
  const d = date instanceof Date ? date : date.toDate();
  return d.toISOString().split('T')[0];
};

// Add months to a date with proper month overflow handling
export const addMonths = (date, months) => {
  const result = new Date(date.getFullYear(), date.getMonth() + months, date.getDate());

  // Handle month overflow (e.g., Jan 31 + 1 month = Feb 28/29, not Mar 3)
  if (result.getDate() !== date.getDate()) {
    // If day changed due to month overflow, set to last day of intended month
    result.setDate(0);
  }

  return result;
};

// Check if date is in the past
export const isPastDate = (date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const compareDate = date instanceof Date ? date : date.toDate();
  return compareDate < today;
};

// Get days difference between two dates
export const daysDifference = (date1, date2) => {
  const d1 = date1 instanceof Date ? date1 : date1.toDate();
  const d2 = date2 instanceof Date ? date2 : date2.toDate();
  const diffTime = Math.abs(d2 - d1);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};
